import config from "./config";
var axios = config();

export default {
  getContractsActive() {
    return axios.get("/api/Contracts/GetActiveContracts", { params: {} });
  },

  getContractAgreementTypes() {
    return axios.get("/api/Contracts/GetActiveContractAgreementTypes", {});
  },

  getContractRestrictionTypes() {
    return axios.get("/api/Contracts/GetActiveContractRestrictionTypes", {});
  },

  getContractStatusDefinitions() {
    return axios.get("/api/Contracts/GetContractStatusDefinitions", {});
  },

  getContractStageDefinitions() {
    return axios.get("/api/Contracts/GetContractStageDefinitions", {});
  },

  getContract(id) {
    return axios.get("/api/Contracts/GetContractById", { params: { id: id } });
  },

  getContractNotes(id) {
    return axios.get("/api/Contracts/GetActiveContractNotes", {
      params: { id: id }
    });
  },

  getContractFile(id) {
    return axios.get("/api/Contracts/GetContractFileById", {
      params: { id: id }
    });
  },

  getContractFiles(contractId) {
    return axios.get("/api/Contracts/GetActiveContractFiles", {
      params: { id: contractId }
    });
  },

  getDownloadContractFile(id) {
    return axios.get("/api/Contracts/DownloadFile", { params: { id: id } });
  },

  getContractFileTypes() {
    return axios.get("/api/Contracts/GetContractFileTypes", {});
  },

  postContract(contract) {
    return axios.post("/api/Contracts/AddContract", contract);
  },

  postEditContract(contract) {
    return axios.post("/api/Contracts/EditContract", contract);
  },

  postCopyContract(contract) {
    return axios.post("/api/Contracts/CopyContract", contract);
  },

  postContractNote(id, note) {
    return axios.post("/api/Contracts/AddContractNote", {
      ContractId: id,
      Notes: note
    });
  },

  postContractFile(formData, file) {
    return axios({
      method: "POST",
      url: "/api/Contracts/AddContractFile",
      transformRequest: function (data) {
        var formData = new FormData();
        // need to convert our json object to a string version of json otherwise
        // the browser will do a 'toString()' on the object which will result
        // in the value '[Object object]' on the server.
        formData.append("data", JSON.stringify(data.data));
        //now add all of the assigned files
        for (var i = 0; i < data.files.length; i++) {
          //add each file to the form data and iteratively name them
          formData.append("file" + i, data.files[i]);
        }
        return formData;
      },
      data: { data: formData, files: [file] } // pass in data as strings
      //headers: { "Content-Type": undefined } // set the headers so angular passing info as form data (not request payload)
    });
  },

  postEditContractFile(formData, files) {
    return axios({
      method: "POST",
      url: "/api/Contracts/EditContractFile",
      transformRequest: function (data) {
        var formData = new FormData();
        // need to convert our json object to a string version of json otherwise
        // the browser will do a 'toString()' on the object which will result
        // in the value '[Object object]' on the server.
        formData.append("data", JSON.stringify(data.data));
        //now add all of the assigned files
        for (var i = 0; i < data.files; i++) {
          //add each file to the form data and iteratively name them
          formData.append("file" + i, data.files[i]);
        }
        return formData;
      },
      data: { data: formData, files: files } // pass in data as strings
      //headers: { "Content-Type": undefined } // set the headers so angular passing info as form data (not request payload)
    });
  },

  deleteContract(contractDeletion) {
    return axios.post("/api/Contracts/DeleteContract", contractDeletion);
  }
};
